// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:960px){.new-action-expansion-panel[data-v-1b71dab3]{max-height:500px;overflow-y:auto;width:98%}}[data-v-1b71dab3]::-webkit-scrollbar{display:none}[data-v-1b71dab3] .v-expansion-panel-content__wrap{padding-left:10px;padding-right:10px}.v-expansion-panel-header[data-v-1b71dab3]{padding-left:10px;padding-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
